module.exports = __webpack_public_path__ + "static/media/S2N6-2.ca528554.svg";